// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- from App.css lines 5728-6084 ---- */
/* ===== CIRCUITS ===== */
.circuits-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 12px;
}

/* Toolbar */
.cr-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.cr-search {
  position: relative;
  min-width: 260px;
  flex: 1 1 260px;
}

.cr-search-ic {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  opacity: .65;
}

.cr-input {
  width: 100%;
  background: var(--glass);
  border: 1px solid var(--line);
  color: var(--fg);
  padding: 10px 12px 10px 34px;
  border-radius: 10px;
  outline: none;
}

.cr-input:focus {
  border-color: rgba(192, 255, 3, 0.55);
  box-shadow: 0 0 0 3px rgba(192, 255, 3, 0.08);
}

.cr-sort {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Grid & Card */
.cr-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

@media (max-width: 960px) {
  .cr-grid {
    grid-template-columns: 1fr;
  }
}

.cr-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 12px;
  box-shadow: var(--shadow);
  cursor: pointer;
  transition: transform .2s, border-color .2s, background .2s;
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 8px;
}

.cr-card:hover {
  transform: translateY(-2px);
  border-color: rgba(192, 255, 3, 0.55);
  background: rgba(255, 255, 255, 0.04);
}

.cr-mini {
  width: 100%;
  height: 130px;
  border-radius: 12px;
  display: block;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--line);
}

.cr-card-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.cr-title {
  color: #fff;
  font-weight: 900;
}

.cr-sub {
  font-size: .9rem;
}

.cr-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cr-meta .pill {
  border: 1px solid var(--line);
  background: var(--glass);
  padding: 6px 10px;
  border-radius: 999px;
  font-size: .88rem;
}

.cr-meta .pill.ghost {
  opacity: .7;
}

/* Empty state */
.cr-empty {
  border: 1px dashed var(--line);
  background: var(--glass);
  border-radius: var(--radius);
  padding: 26px;
  text-align: center;
}

.cr-empty-emoji {
  font-size: 2rem;
}

.cr-empty-title {
  color: #fff;
  font-weight: 900;
  margin: 6px 0;
}

/* Skeleton */
.cr-skel {
  position: relative;
  overflow: hidden;
}

.cr-skel .cr-mini {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.08);
}

.cr-skel-line {
  height: 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
}

.cr-skel-line.short {
  width: 60%;
}

.cr-skel::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.06), transparent);
  transform: translateX(-100%);
  animation: crShimmer 1.3s infinite;
}

@keyframes crShimmer {
  to {
    transform: translateX(100%);
  }
}

/* Modal */
.cr-modal {
  position: fixed;
  inset: 0;
  z-index: 50;
}

.cr-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.cr-dialog {
  position: relative;
  inset: auto 0 0 0;
  margin: auto;
  /* top: 6%; */
  /* max-width: 980px; */
  width: calc(100% - 24px);
  background: linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(10, 10, 10, 0.98));
  border: 1px solid var(--line);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 16px;

  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.cr-close {
  position: absolute;
  top: 8px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 28px;
  color: var(--fg);
  cursor: pointer;
  line-height: 1;
}

.cr-dialog-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 6px 0 12px;
}

.cr-dialog-title {
  margin: 0;
  color: #fff;
}

.cr-dialog-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cr-body {
  display: grid;
  grid-template-columns: 1.2fr .8fr;
  gap: 14px;
}

@media (max-width: 960px) {
  .cr-body {
    grid-template-columns: 1fr;
  }
}

.cr-block {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px;
}

.cr-block-title {
  margin-bottom: 8px;
  color: #fff;
}

.cr-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.cr-key {
  color: var(--muted);
}

.cr-val {
  color: #fff;
  font-weight: 800;
}

.cr-canvas {
  width: 100%;
  height: auto;
  border-radius: 12px;
  display: block;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--line);
}

/* MiniTrack: stato di caricamento */
.cr-mini.loading {
  position: relative;
  overflow: hidden;
}

.cr-mini.loading::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.07), transparent);
  transform: translateX(-100%);
  animation: crMiniShimmer 1.2s infinite;
  border-radius: 12px;
}

@keyframes crMiniShimmer {
  to {
    transform: translateX(100%);
  }
}

/* --- Icone nelle pill e nella searchbar --- */
.pill .pill-ic {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  flex: 0 0 auto;
  display: inline-block;
  vertical-align: -2px;
}

.cr-search-ic svg {
  width: 18px;
  height: 18px;
  opacity: .9;
}

/* allineamento pill con icone */
.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* (già presente) shimmer per la mini mappa quando carica */
.cr-mini.loading {
  position: relative;
  overflow: hidden;
}

.cr-mini.loading::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.07), transparent);
  transform: translateX(-100%);
  animation: crMiniShimmer 1.2s infinite;
  border-radius: 12px;
}

@keyframes crMiniShimmer {
  to {
    transform: translateX(100%);
  }
}

/* ---- from App.css lines 6100-6258 ---- */
/* ===== EDITOR SETTORI E CORDOLI ===== */
.ed-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--line);
}

.ed-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.ed-panel {
  margin-top: 20px;
  display: grid;
  gap: 16px;
}

.ed-section {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 14px;
}

.ed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.ed-title {
  color: var(--brand);
  font-weight: 800;
  font-size: 1rem;
  letter-spacing: .5px;
}

.ed-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ed-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--line);
  border-radius: 10px;
  overflow: hidden;
  transition: border-color .2s;
}

.ed-item:hover {
  border-color: rgba(192, 255, 3, 0.35);
}

.ed-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ed-item-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.ed-item-kerb {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: repeating-linear-gradient(45deg,
      #ff0000,
      #ff0000 3px,
      #ffffff 3px,
      #ffffff 6px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.ed-item-name {
  font-weight: 700;
  color: white;
  flex: 0 0 auto;
}

.ed-item-range {
  color: var(--muted);
  font-size: .88rem;
  flex: 1 1 auto;
}

.ed-item-del {
  background: transparent;
  border: none;
  color: var(--error);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: grid;
  place-items: center;
  transition: background .2s;
}

.ed-item-del:hover {
  background: rgba(255, 107, 107, 0.15);
}

.ed-item-body {
  padding: 12px;
  border-top: 1px solid var(--line);
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ed-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ed-row label {
  font-size: .9rem;
  color: var(--fg);
  font-weight: 600;
}

.ed-empty {
  padding: 16px;
  text-align: center;
}

/* Responsive editor */
@media (max-width: 960px) {
  .ed-toolbar {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .ed-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

/* ---- from App.css lines 9406-10318 ---- */
/* ===== PREMIUM CIRCUITS PAGE STYLES ===== */

.circuits-page {
  min-height: 100vh;
  background: #000;
}

/* Circuits Header Premium */
.circuits-header-premium {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, rgba(225, 6, 0, 0.08), rgba(225, 6, 0, 0.02));
  border: 1px solid rgba(225, 6, 0, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);
}

.circuits-header-content {
  flex: 1 1;
}

.circuits-stats {
  display: flex;
  gap: 20px;
}

/* Toolbar Premium */
.circuits-toolbar-premium {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 12px;
}

.toolbar-search {
  position: relative;
  flex: 1 1;
}

.search-icon-circuits {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--muted);
  pointer-events: none;
  display: flex;
  align-items: center;
}

.input-search-circuits {
  width: 100%;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 12px 16px 12px 44px;
  color: var(--fg);
  font-size: 0.95rem;
  outline: none;
  transition: all 0.3s ease;
}

.input-search-circuits:focus {
  border-color: rgba(225, 6, 0, 0.6);
  box-shadow: 0 0 0 3px rgba(225, 6, 0, 0.1);
}

.toolbar-sort {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sort-label {
  font-size: 0.9rem;
  color: var(--muted);
  font-weight: 600;
  white-space: nowrap;
}

.select-premium {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 14px;
  color: var(--fg);
  font-size: 0.95rem;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 180px;
}

.select-premium:focus {
  border-color: rgba(225, 6, 0, 0.6);
  box-shadow: 0 0 0 3px rgba(225, 6, 0, 0.1);
}

.circuits-list-header {
  margin-bottom: 24px;
}

/* Circuits Grid Premium */
.circuits-grid-premium {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

/* Circuit Card Premium */
.circuit-card-premium {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s ease;
  position: relative;
  cursor: pointer;
}

.circuit-card-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(225, 6, 0, 0.08), transparent);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 1;
}

.circuit-card-premium:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(225, 6, 0, 0.4);
}

.circuit-card-premium:hover::before {
  opacity: 1;
}

.circuit-preview-container {
  position: relative;
  height: 150px;
  background: rgba(0, 0, 0, 0.2);
}

.cr-mini {
  width: 100%;
  height: 100%;
  display: block;
}

.circuit-overlay-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.7));
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}

.circuit-card-premium:hover .circuit-overlay-card {
  opacity: 1;
}

.btn-delete-overlay-circuit {
  background: rgba(255, 107, 107, 0.9);
  color: white;
  border: 1px solid rgba(255, 107, 107, 0.3);
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  backdrop-filter: blur(10px);
}

.btn-delete-overlay-circuit:hover:not(:disabled) {
  background: rgba(255, 107, 107, 1);
  transform: scale(1.05);
}

.circuit-card-content {
  padding: 16px;
  position: relative;
  z-index: 2;
}

.circuit-card-header {
  margin-bottom: 12px;
}

.circuit-title-premium {
  font-size: 1.2rem;
  font-weight: 900;
  margin: 0 0 6px 0;
  color: var(--fg);
  letter-spacing: -0.3px;
}

.circuit-date {
  font-size: 0.85rem;
  color: var(--muted);
  font-weight: 600;
}

.circuit-card-footer {
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.circuit-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.circuit-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--line);
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  color: var(--fg);
  font-weight: 600;
}

.badge-icon {
  color: #e10600;
}

/* Modal Premium */
.cr-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.cr-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
}

.cr-dialog {
  position: relative;
  background: linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(15, 15, 15, 0.98));
  border: 1px solid rgba(225, 6, 0, 0.2);
  border-radius: 20px;
  /* max-width: 1400px; */
  width: 80vw;
  max-height: 90vh;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  z-index: 1;
  overflow: hidden;
}

.cr-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid var(--line);
  color: var(--fg);
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
  transition: all 0.3s ease;
  z-index: 10;
}

.cr-close:hover {
  background: rgba(255, 107, 107, 0.2);
  color: var(--down);
  transform: rotate(90deg);
}

.modal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 20px;
}

/* Circuit Detail Split Screen Layout */
.circuit-detail-split {
  display: flex;
  height: 85vh;
  max-height: 720px;
  gap: 0;
}

/* Left Panel - Canvas */
.circuit-detail-left {
  flex: 1.2 1;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.3);
  border-right: 1px solid rgba(225, 6, 0, 0.2);
  padding: 24px;
}

.circuit-canvas-header {
  margin-bottom: 20px;
}

.canvas-title {
  font-size: 1.6rem;
  font-weight: 900;
  margin: 0 0 6px 0;
  color: #e10600;
  letter-spacing: -0.5px;
  text-shadow: 0 0 20px rgba(225, 6, 0, 0.3);
}

.canvas-subtitle {
  font-size: 0.9rem;
  color: var(--muted);
  font-weight: 600;
}

.canvas-container-split {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 16px;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.3);
}

.cr-canvas {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

/* Right Panel - Info/Editor with Tabs */
.circuit-detail-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(15, 15, 15, 0.6);
  overflow: hidden;
}

/* Tab Navigation */
.circuit-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid rgba(225, 6, 0, 0.15);
  background: rgba(0, 0, 0, 0.3);
  padding: 0 24px;
}

.circuit-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 20px;
  background: transparent;
  border: none;
  color: var(--muted);
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  position: relative;
}

.circuit-tab:hover {
  color: var(--fg);
  background: rgba(255, 255, 255, 0.03);
}

.circuit-tab.active {
  color: #e10600;
  border-bottom-color: #e10600;
  background: rgba(225, 6, 0, 0.05);
}

.circuit-tab svg {
  transition: transform 0.3s ease;
}

.circuit-tab.active svg {
  transform: scale(1.1);
}

/* Tab Content Area */
.circuit-tab-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

/* Info View */
.circuit-info-view {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
}

.info-section {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 20px;
}

.info-section-title {
  font-size: 1.1rem;
  font-weight: 800;
  margin: 0 0 16px 0;
  color: var(--fg);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(225, 6, 0, 0.2);
  padding-bottom: 10px;
}

.info-grid-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.info-item-split {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: all 0.3s ease;
}

.info-item-split:hover {
  border-color: rgba(225, 6, 0, 0.4);
  background: rgba(225, 6, 0, 0.03);
}

.info-label-split {
  font-size: 0.75rem;
  color: var(--muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.info-value-split {
  font-size: 1rem;
  color: var(--fg);
  font-weight: 800;
}

/* Sectors Preview */
.sectors-preview-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sector-preview-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 12px 14px;
  transition: all 0.3s ease;
}

.sector-preview-item:hover {
  border-color: rgba(225, 6, 0, 0.4);
  background: rgba(225, 6, 0, 0.03);
}

.sector-preview-color {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 2px solid var(--line);
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.sector-preview-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sector-preview-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--fg);
}

.sector-preview-range {
  font-size: 0.8rem;
  color: var(--muted);
  font-weight: 600;
}

.sectors-preview-empty {
  text-align: center;
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px dashed var(--line);
  border-radius: 8px;
}

/* Info Actions */
.info-actions {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid var(--line);
}

.btn-danger-split {
  width: 100%;
  background: transparent;
  color: var(--down);
  border: 1px solid rgba(255, 107, 107, 0.5);
  padding: 12px 20px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 700;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-danger-split:hover:not(:disabled) {
  background: rgba(255, 107, 107, 0.12);
  border-color: rgba(255, 107, 107, 0.8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
}

.btn-danger-split:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Editor View */
.circuit-editor-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
}

.editor-actions {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid var(--line);
  display: flex;
  gap: 12px;
}

.btn-ghost-split {
  flex: 1 1;
  background: transparent;
  border: 1px solid var(--line);
  color: var(--fg);
  padding: 12px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.btn-ghost-split:hover {
  background: var(--glass);
  border-color: rgba(225, 6, 0, 0.3);
}

.btn-primary-split {
  flex: 1.5 1;
  background: linear-gradient(135deg, #e10600, #ff3333);
  border: none;
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 800;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(225, 6, 0, 0.3);
}

.btn-primary-split:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(225, 6, 0, 0.4);
}

.btn-primary-split:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.sector-editor-premium {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 20px;
}

.sector-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.sector-editor-title {
  font-size: 1.3rem;
  font-weight: 800;
  margin: 0;
  color: var(--fg);
  display: flex;
  align-items: center;
  gap: 12px;
}

.sector-count-badge {
  background: rgba(225, 6, 0, 0.15);
  color: #e10600;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 800;
}

.sector-list-premium {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sector-item-premium {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--line);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.sector-item-premium.expanded {
  border-color: rgba(225, 6, 0, 0.4);
}

.sector-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.sector-item-header:hover {
  background: rgba(255, 255, 255, 0.05);
}

.sector-color-indicator {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 2px solid var(--line);
  flex-shrink: 0;
}

.sector-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sector-name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--fg);
}

.sector-range {
  font-size: 0.85rem;
  color: var(--muted);
  font-weight: 600;
}

.sector-delete-btn {
  background: transparent;
  border: 1px solid rgba(255, 107, 107, 0.4);
  color: var(--down);
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sector-delete-btn:hover {
  background: rgba(255, 107, 107, 0.12);
  transform: rotate(90deg);
}

.sector-item-body {
  padding: 16px;
  border-top: 1px solid var(--line);
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sector-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sector-field label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--fg);
}

.sector-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.color-picker-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
}

.color-picker-input {
  width: 48px;
  height: 32px;
  border: 1px solid var(--line);
  border-radius: 6px;
  cursor: pointer;
}

.color-value {
  font-size: 0.9rem;
  color: var(--muted);
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

.sector-empty-state {
  text-align: center;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px dashed var(--line);
  border-radius: 10px;
}

/* Responsive Circuits */
@media (max-width: 768px) {
  .circuits-header-premium {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .circuits-stats {
    width: 100%;
    justify-content: center;
  }

  .circuits-toolbar-premium {
    flex-direction: column;
    align-items: stretch;
  }

  .toolbar-sort {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .select-premium {
    width: 100%;
  }

  .circuits-grid-premium {
    grid-template-columns: 1fr;
  }

  .circuit-detail-split {
    flex-direction: column;
    height: auto;
    max-height: none;
  }

  .circuit-detail-left {
    border-right: none;
    border-bottom: 1px solid rgba(225, 6, 0, 0.2);
    padding: 16px;
  }

  .canvas-title {
    font-size: 1.3rem;
  }

  .canvas-container-split {
    padding: 12px;
  }

  .circuit-detail-right {
    overflow: visible;
  }

  .circuit-tabs {
    padding: 0 16px;
  }

  .circuit-tab {
    padding: 14px 16px;
    font-size: 0.9rem;
  }

  .circuit-tab-content {
    padding: 16px;
  }

  .info-grid-split {
    grid-template-columns: 1fr;
  }

  .sector-field-row {
    grid-template-columns: 1fr;
  }

  .editor-actions {
    flex-direction: column;
  }

  .btn-ghost-split,
  .btn-primary-split {
    flex: 1 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/legacy/circuits-legacy.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uFAAuF;EACvF,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,mFAAmF;EACnF,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;;EAEb,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uFAAuF;EACvF,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uFAAuF;EACvF,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,2CAA2C;AAC3C,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;kBAIgB;EAChB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA,4CAA4C;AAC5C,6CAA6C;;AAE7C;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iFAAiF;EACjF,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mFAAmF;EACnF,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,MAAM;AACR;;AAEA,wBAAwB;AACxB;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,MAAM;EACN,8CAA8C;EAC9C,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAS;EACT,qDAAqD;EACrD,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,SAAO;EACT;AACF","sourcesContent":["/* ---- from App.css lines 5728-6084 ---- */\n/* ===== CIRCUITS ===== */\n.circuits-header {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n/* Toolbar */\n.cr-toolbar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.cr-search {\n  position: relative;\n  min-width: 260px;\n  flex: 1 1 260px;\n}\n\n.cr-search-ic {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: .65;\n}\n\n.cr-input {\n  width: 100%;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  color: var(--fg);\n  padding: 10px 12px 10px 34px;\n  border-radius: 10px;\n  outline: none;\n}\n\n.cr-input:focus {\n  border-color: rgba(192, 255, 3, 0.55);\n  box-shadow: 0 0 0 3px rgba(192, 255, 3, 0.08);\n}\n\n.cr-sort {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Grid & Card */\n.cr-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n@media (max-width: 960px) {\n  .cr-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cr-card {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 12px;\n  box-shadow: var(--shadow);\n  cursor: pointer;\n  transition: transform .2s, border-color .2s, background .2s;\n  display: grid;\n  grid-template-rows: auto auto auto;\n  gap: 8px;\n}\n\n.cr-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(192, 255, 3, 0.55);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.cr-mini {\n  width: 100%;\n  height: 130px;\n  border-radius: 12px;\n  display: block;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--line);\n}\n\n.cr-card-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n\n.cr-title {\n  color: #fff;\n  font-weight: 900;\n}\n\n.cr-sub {\n  font-size: .9rem;\n}\n\n.cr-meta {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cr-meta .pill {\n  border: 1px solid var(--line);\n  background: var(--glass);\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: .88rem;\n}\n\n.cr-meta .pill.ghost {\n  opacity: .7;\n}\n\n/* Empty state */\n.cr-empty {\n  border: 1px dashed var(--line);\n  background: var(--glass);\n  border-radius: var(--radius);\n  padding: 26px;\n  text-align: center;\n}\n\n.cr-empty-emoji {\n  font-size: 2rem;\n}\n\n.cr-empty-title {\n  color: #fff;\n  font-weight: 900;\n  margin: 6px 0;\n}\n\n/* Skeleton */\n.cr-skel {\n  position: relative;\n  overflow: hidden;\n}\n\n.cr-skel .cr-mini {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.cr-skel-line {\n  height: 12px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.cr-skel-line.short {\n  width: 60%;\n}\n\n.cr-skel::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.06), transparent);\n  transform: translateX(-100%);\n  animation: crShimmer 1.3s infinite;\n}\n\n@keyframes crShimmer {\n  to {\n    transform: translateX(100%);\n  }\n}\n\n/* Modal */\n.cr-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n}\n\n.cr-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.cr-dialog {\n  position: relative;\n  inset: auto 0 0 0;\n  margin: auto;\n  /* top: 6%; */\n  /* max-width: 980px; */\n  width: calc(100% - 24px);\n  background: linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(10, 10, 10, 0.98));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  box-shadow: var(--shadow);\n  padding: 16px;\n\n  max-height: 90vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cr-close {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  color: var(--fg);\n  cursor: pointer;\n  line-height: 1;\n}\n\n.cr-dialog-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 6px 0 12px;\n}\n\n.cr-dialog-title {\n  margin: 0;\n  color: #fff;\n}\n\n.cr-dialog-tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.cr-body {\n  display: grid;\n  grid-template-columns: 1.2fr .8fr;\n  gap: 14px;\n}\n\n@media (max-width: 960px) {\n  .cr-body {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cr-block {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.cr-block-title {\n  margin-bottom: 8px;\n  color: #fff;\n}\n\n.cr-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.cr-key {\n  color: var(--muted);\n}\n\n.cr-val {\n  color: #fff;\n  font-weight: 800;\n}\n\n.cr-canvas {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  display: block;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--line);\n}\n\n/* MiniTrack: stato di caricamento */\n.cr-mini.loading {\n  position: relative;\n  overflow: hidden;\n}\n\n.cr-mini.loading::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.07), transparent);\n  transform: translateX(-100%);\n  animation: crMiniShimmer 1.2s infinite;\n  border-radius: 12px;\n}\n\n@keyframes crMiniShimmer {\n  to {\n    transform: translateX(100%);\n  }\n}\n\n/* --- Icone nelle pill e nella searchbar --- */\n.pill .pill-ic {\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n  flex: 0 0 auto;\n  display: inline-block;\n  vertical-align: -2px;\n}\n\n.cr-search-ic svg {\n  width: 18px;\n  height: 18px;\n  opacity: .9;\n}\n\n/* allineamento pill con icone */\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* (già presente) shimmer per la mini mappa quando carica */\n.cr-mini.loading {\n  position: relative;\n  overflow: hidden;\n}\n\n.cr-mini.loading::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.07), transparent);\n  transform: translateX(-100%);\n  animation: crMiniShimmer 1.2s infinite;\n  border-radius: 12px;\n}\n\n@keyframes crMiniShimmer {\n  to {\n    transform: translateX(100%);\n  }\n}\n\n/* ---- from App.css lines 6100-6258 ---- */\n/* ===== EDITOR SETTORI E CORDOLI ===== */\n.ed-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--line);\n}\n\n.ed-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.ed-panel {\n  margin-top: 20px;\n  display: grid;\n  gap: 16px;\n}\n\n.ed-section {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.ed-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.ed-title {\n  color: var(--brand);\n  font-weight: 800;\n  font-size: 1rem;\n  letter-spacing: .5px;\n}\n\n.ed-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ed-item {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: border-color .2s;\n}\n\n.ed-item:hover {\n  border-color: rgba(192, 255, 3, 0.35);\n}\n\n.ed-item-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ed-item-color {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  flex-shrink: 0;\n}\n\n.ed-item-kerb {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  background: repeating-linear-gradient(45deg,\n      #ff0000,\n      #ff0000 3px,\n      #ffffff 3px,\n      #ffffff 6px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  flex-shrink: 0;\n}\n\n.ed-item-name {\n  font-weight: 700;\n  color: white;\n  flex: 0 0 auto;\n}\n\n.ed-item-range {\n  color: var(--muted);\n  font-size: .88rem;\n  flex: 1 1 auto;\n}\n\n.ed-item-del {\n  background: transparent;\n  border: none;\n  color: var(--error);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: grid;\n  place-items: center;\n  transition: background .2s;\n}\n\n.ed-item-del:hover {\n  background: rgba(255, 107, 107, 0.15);\n}\n\n.ed-item-body {\n  padding: 12px;\n  border-top: 1px solid var(--line);\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ed-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ed-row label {\n  font-size: .9rem;\n  color: var(--fg);\n  font-weight: 600;\n}\n\n.ed-empty {\n  padding: 16px;\n  text-align: center;\n}\n\n/* Responsive editor */\n@media (max-width: 960px) {\n  .ed-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .ed-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n/* ---- from App.css lines 9406-10318 ---- */\n/* ===== PREMIUM CIRCUITS PAGE STYLES ===== */\n\n.circuits-page {\n  min-height: 100vh;\n  background: #000;\n}\n\n/* Circuits Header Premium */\n.circuits-header-premium {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, rgba(225, 6, 0, 0.08), rgba(225, 6, 0, 0.02));\n  border: 1px solid rgba(225, 6, 0, 0.2);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.circuits-header-content {\n  flex: 1;\n}\n\n.circuits-stats {\n  display: flex;\n  gap: 20px;\n}\n\n/* Toolbar Premium */\n.circuits-toolbar-premium {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 12px;\n}\n\n.toolbar-search {\n  position: relative;\n  flex: 1;\n}\n\n.search-icon-circuits {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--muted);\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n}\n\n.input-search-circuits {\n  width: 100%;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 12px 16px 12px 44px;\n  color: var(--fg);\n  font-size: 0.95rem;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.input-search-circuits:focus {\n  border-color: rgba(225, 6, 0, 0.6);\n  box-shadow: 0 0 0 3px rgba(225, 6, 0, 0.1);\n}\n\n.toolbar-sort {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sort-label {\n  font-size: 0.9rem;\n  color: var(--muted);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.select-premium {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 10px 14px;\n  color: var(--fg);\n  font-size: 0.95rem;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 180px;\n}\n\n.select-premium:focus {\n  border-color: rgba(225, 6, 0, 0.6);\n  box-shadow: 0 0 0 3px rgba(225, 6, 0, 0.1);\n}\n\n.circuits-list-header {\n  margin-bottom: 24px;\n}\n\n/* Circuits Grid Premium */\n.circuits-grid-premium {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n/* Circuit Card Premium */\n.circuit-card-premium {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  overflow: hidden;\n  transition: all 0.4s ease;\n  position: relative;\n  cursor: pointer;\n}\n\n.circuit-card-premium::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(225, 6, 0, 0.08), transparent);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.circuit-card-premium:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);\n  border-color: rgba(225, 6, 0, 0.4);\n}\n\n.circuit-card-premium:hover::before {\n  opacity: 1;\n}\n\n.circuit-preview-container {\n  position: relative;\n  height: 150px;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.cr-mini {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.circuit-overlay-card {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.7));\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  padding: 12px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: 2;\n}\n\n.circuit-card-premium:hover .circuit-overlay-card {\n  opacity: 1;\n}\n\n.btn-delete-overlay-circuit {\n  background: rgba(255, 107, 107, 0.9);\n  color: white;\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.85rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  backdrop-filter: blur(10px);\n}\n\n.btn-delete-overlay-circuit:hover:not(:disabled) {\n  background: rgba(255, 107, 107, 1);\n  transform: scale(1.05);\n}\n\n.circuit-card-content {\n  padding: 16px;\n  position: relative;\n  z-index: 2;\n}\n\n.circuit-card-header {\n  margin-bottom: 12px;\n}\n\n.circuit-title-premium {\n  font-size: 1.2rem;\n  font-weight: 900;\n  margin: 0 0 6px 0;\n  color: var(--fg);\n  letter-spacing: -0.3px;\n}\n\n.circuit-date {\n  font-size: 0.85rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.circuit-card-footer {\n  padding-top: 12px;\n  border-top: 1px solid var(--line);\n}\n\n.circuit-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.circuit-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--line);\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  color: var(--fg);\n  font-weight: 600;\n}\n\n.badge-icon {\n  color: #e10600;\n}\n\n/* Modal Premium */\n.cr-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.cr-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n}\n\n.cr-dialog {\n  position: relative;\n  background: linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(15, 15, 15, 0.98));\n  border: 1px solid rgba(225, 6, 0, 0.2);\n  border-radius: 20px;\n  /* max-width: 1400px; */\n  width: 80vw;\n  max-height: 90vh;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  z-index: 1;\n  overflow: hidden;\n}\n\n.cr-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid var(--line);\n  color: var(--fg);\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1.5rem;\n  line-height: 1;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.cr-close:hover {\n  background: rgba(255, 107, 107, 0.2);\n  color: var(--down);\n  transform: rotate(90deg);\n}\n\n.modal-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 20px;\n}\n\n/* Circuit Detail Split Screen Layout */\n.circuit-detail-split {\n  display: flex;\n  height: 85vh;\n  max-height: 720px;\n  gap: 0;\n}\n\n/* Left Panel - Canvas */\n.circuit-detail-left {\n  flex: 1.2;\n  display: flex;\n  flex-direction: column;\n  background: rgba(0, 0, 0, 0.3);\n  border-right: 1px solid rgba(225, 6, 0, 0.2);\n  padding: 24px;\n}\n\n.circuit-canvas-header {\n  margin-bottom: 20px;\n}\n\n.canvas-title {\n  font-size: 1.6rem;\n  font-weight: 900;\n  margin: 0 0 6px 0;\n  color: #e10600;\n  letter-spacing: -0.5px;\n  text-shadow: 0 0 20px rgba(225, 6, 0, 0.3);\n}\n\n.canvas-subtitle {\n  font-size: 0.9rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.canvas-container-split {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.cr-canvas {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n/* Right Panel - Info/Editor with Tabs */\n.circuit-detail-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: rgba(15, 15, 15, 0.6);\n  overflow: hidden;\n}\n\n/* Tab Navigation */\n.circuit-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid rgba(225, 6, 0, 0.15);\n  background: rgba(0, 0, 0, 0.3);\n  padding: 0 24px;\n}\n\n.circuit-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 20px;\n  background: transparent;\n  border: none;\n  color: var(--muted);\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  position: relative;\n}\n\n.circuit-tab:hover {\n  color: var(--fg);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.circuit-tab.active {\n  color: #e10600;\n  border-bottom-color: #e10600;\n  background: rgba(225, 6, 0, 0.05);\n}\n\n.circuit-tab svg {\n  transition: transform 0.3s ease;\n}\n\n.circuit-tab.active svg {\n  transform: scale(1.1);\n}\n\n/* Tab Content Area */\n.circuit-tab-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n/* Info View */\n.circuit-info-view {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 100%;\n}\n\n.info-section {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.info-section-title {\n  font-size: 1.1rem;\n  font-weight: 800;\n  margin: 0 0 16px 0;\n  color: var(--fg);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid rgba(225, 6, 0, 0.2);\n  padding-bottom: 10px;\n}\n\n.info-grid-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.info-item-split {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  transition: all 0.3s ease;\n}\n\n.info-item-split:hover {\n  border-color: rgba(225, 6, 0, 0.4);\n  background: rgba(225, 6, 0, 0.03);\n}\n\n.info-label-split {\n  font-size: 0.75rem;\n  color: var(--muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n.info-value-split {\n  font-size: 1rem;\n  color: var(--fg);\n  font-weight: 800;\n}\n\n/* Sectors Preview */\n.sectors-preview-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sector-preview-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  padding: 12px 14px;\n  transition: all 0.3s ease;\n}\n\n.sector-preview-item:hover {\n  border-color: rgba(225, 6, 0, 0.4);\n  background: rgba(225, 6, 0, 0.03);\n}\n\n.sector-preview-color {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 2px solid var(--line);\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.sector-preview-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sector-preview-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--fg);\n}\n\n.sector-preview-range {\n  font-size: 0.8rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.sectors-preview-empty {\n  text-align: center;\n  padding: 30px 20px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px dashed var(--line);\n  border-radius: 8px;\n}\n\n/* Info Actions */\n.info-actions {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid var(--line);\n}\n\n.btn-danger-split {\n  width: 100%;\n  background: transparent;\n  color: var(--down);\n  border: 1px solid rgba(255, 107, 107, 0.5);\n  padding: 12px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 700;\n  font-size: 0.95rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-danger-split:hover:not(:disabled) {\n  background: rgba(255, 107, 107, 0.12);\n  border-color: rgba(255, 107, 107, 0.8);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);\n}\n\n.btn-danger-split:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Editor View */\n.circuit-editor-view {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 20px;\n}\n\n.editor-actions {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid var(--line);\n  display: flex;\n  gap: 12px;\n}\n\n.btn-ghost-split {\n  flex: 1;\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--fg);\n  padding: 12px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n}\n\n.btn-ghost-split:hover {\n  background: var(--glass);\n  border-color: rgba(225, 6, 0, 0.3);\n}\n\n.btn-primary-split {\n  flex: 1.5;\n  background: linear-gradient(135deg, #e10600, #ff3333);\n  border: none;\n  color: #fff;\n  padding: 12px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 800;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(225, 6, 0, 0.3);\n}\n\n.btn-primary-split:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(225, 6, 0, 0.4);\n}\n\n.btn-primary-split:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.sector-editor-premium {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.sector-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.sector-editor-title {\n  font-size: 1.3rem;\n  font-weight: 800;\n  margin: 0;\n  color: var(--fg);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sector-count-badge {\n  background: rgba(225, 6, 0, 0.15);\n  color: #e10600;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  font-weight: 800;\n}\n\n.sector-list-premium {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sector-item-premium {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.sector-item-premium.expanded {\n  border-color: rgba(225, 6, 0, 0.4);\n}\n\n.sector-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.sector-item-header:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.sector-color-indicator {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  border: 2px solid var(--line);\n  flex-shrink: 0;\n}\n\n.sector-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sector-name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--fg);\n}\n\n.sector-range {\n  font-size: 0.85rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.sector-delete-btn {\n  background: transparent;\n  border: 1px solid rgba(255, 107, 107, 0.4);\n  color: var(--down);\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sector-delete-btn:hover {\n  background: rgba(255, 107, 107, 0.12);\n  transform: rotate(90deg);\n}\n\n.sector-item-body {\n  padding: 16px;\n  border-top: 1px solid var(--line);\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.sector-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sector-field label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--fg);\n}\n\n.sector-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.color-picker-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n}\n\n.color-picker-input {\n  width: 48px;\n  height: 32px;\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.color-value {\n  font-size: 0.9rem;\n  color: var(--muted);\n  font-weight: 600;\n  font-family: 'Courier New', monospace;\n}\n\n.sector-empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px dashed var(--line);\n  border-radius: 10px;\n}\n\n/* Responsive Circuits */\n@media (max-width: 768px) {\n  .circuits-header-premium {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n\n  .circuits-stats {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .circuits-toolbar-premium {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .toolbar-sort {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .select-premium {\n    width: 100%;\n  }\n\n  .circuits-grid-premium {\n    grid-template-columns: 1fr;\n  }\n\n  .circuit-detail-split {\n    flex-direction: column;\n    height: auto;\n    max-height: none;\n  }\n\n  .circuit-detail-left {\n    border-right: none;\n    border-bottom: 1px solid rgba(225, 6, 0, 0.2);\n    padding: 16px;\n  }\n\n  .canvas-title {\n    font-size: 1.3rem;\n  }\n\n  .canvas-container-split {\n    padding: 12px;\n  }\n\n  .circuit-detail-right {\n    overflow: visible;\n  }\n\n  .circuit-tabs {\n    padding: 0 16px;\n  }\n\n  .circuit-tab {\n    padding: 14px 16px;\n    font-size: 0.9rem;\n  }\n\n  .circuit-tab-content {\n    padding: 16px;\n  }\n\n  .info-grid-split {\n    grid-template-columns: 1fr;\n  }\n\n  .sector-field-row {\n    grid-template-columns: 1fr;\n  }\n\n  .editor-actions {\n    flex-direction: column;\n  }\n\n  .btn-ghost-split,\n  .btn-primary-split {\n    flex: 1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
